import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { decodeUrl } from '@taleemabad/shared';

class DeepLinkService {
  async initDeepLinks() {
    if (Capacitor.isNativePlatform()) {
      App.addListener('appUrlOpen', async (event) => {
        if (event.url.includes('schools.niete.pk')) {
          localStorage.setItem('deepLink', event.url); // store the deep link in local storagee
          const decodeData = decodeUrl(event.url); // decode the deep link
          if (decodeData?.username && decodeData?.name) {
            window.open(`/login`, '_self');
          }
        }
      });
    }
  }
}
export const deepLinkService = new DeepLinkService();
